import moment from 'moment';

moment.locale('fr');

export const LISTE_JOURS = moment.weekdaysShort(false);
export const LISTE_JOURS_LONG = moment.weekdays(false);
export const LISTE_MOIS = moment.months(true);
export const JOUR_DEBUT_SEMAINE = moment.localeData().firstDayOfWeek();

export function dateParser(date) {
  const m = moment(date, 'DD-MM-YYYY');
  return m.isValid() ? m.toDate() : null;
}

export const LISTE_INDEX_JOURS = [
  { number: 0, libelle: LISTE_JOURS_LONG[0] },
  { number: 1, libelle: LISTE_JOURS_LONG[1] },
  { number: 2, libelle: LISTE_JOURS_LONG[2] },
  { number: 3, libelle: LISTE_JOURS_LONG[3] },
  { number: 4, libelle: LISTE_JOURS_LONG[4] },
  { number: 5, libelle: LISTE_JOURS_LONG[5] },
  { number: 6, libelle: LISTE_JOURS_LONG[6] },
];
